import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  FixedAssetCategory, FixedAssetCategoryRequest, MapCategoriesResult,
} from '../interfaces/fixedAsset/cwip.interface';

export const FixedAssetCategoryService = {
  list: async (institutionId: string): Promise<FixedAssetCategory[]> =>
    (await axios.get(ENDPOINTS.FIXED_ASSET_CATEGORY.LIST(institutionId))).data,
  create: async (institutionId: string, req: FixedAssetCategoryRequest): Promise<FixedAssetCategory> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET_CATEGORY.CREATE(institutionId), req)).data,
  update: async (id: string, req: FixedAssetCategoryRequest): Promise<FixedAssetCategory> =>
    (await axios.put(ENDPOINTS.FIXED_ASSET_CATEGORY.UPDATE(id), req)).data,
  deactivate: async (id: string): Promise<FixedAssetCategory> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET_CATEGORY.DEACTIVATE(id))).data,
  activate: async (id: string): Promise<FixedAssetCategory> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET_CATEGORY.ACTIVATE(id))).data,
  mapCategories: async (institutionId: string): Promise<MapCategoriesResult> =>
    (await axios.post(ENDPOINTS.FIXED_ASSET_CATEGORY.MAP(institutionId))).data,
};
